import React, { useEffect, useState} from "react";
import Header from "../components/Header";
import Product4 from "../components/Product4";
import { Link , useLocation ,useParams } from "react-router-dom";
import { useAxios } from "../services/useAxios";
import {alert, confirm} from "../components/MegConfirmAlert";
import { useTranslation } from 'react-i18next';
import { useForm} from "react-hook-form";

export default function OrderCancel(){
    const { t } = useTranslation();

    const [data, setData] = useState({});
    let {id} = useParams();
    const [request] = useAxios();

    const {register, handleSubmit, formState , setFocus, watch, setValue, clearErrors }= useForm();
    const{errors} = formState;
    const [returnValue, setReturnValue] = useState(0);

    const [cancelResnCode, setCancelResnCode] = useState('');
    const [cancelResnDetail, setCancelResnDetail] = useState('');
    
    const [isAgr, setAgr] = useState(false);
    
    const fetchData = async () => {
       
        const response = await request.post("/app/mypage/getMyOrderCancelTargetInfoAPI", {
            orderNo: id
        });

        if(response.data.resultCode === 200){

            if((response.data.result.orderDelivInfo.orderProcessSttusCode !=='ODR001' && 
                response.data.result.orderDelivInfo.orderProcessSttusCode !=='ODR002' &&
                response.data.result.orderDelivInfo.orderProcessSttusCode !=='ODR003')){  

                window.location.href="/OrderHistory";
            }else{
                console.log(response.data.result)
                setData(response.data.result);   

            }


                   
                  
        }
    };

    const onSubmit = async formData=> {
        

        if(!isAgr){
            alert("주문취소에 대하여 동의하여 주십시오.")
            return
        }

        const orderDetailList = [];
        data.orderDelivDetailList.forEach((el) => orderDetailList.push(el.orderDetailSn));

        const response = await request.post("/app/mypage/procMyOrderCancelAPI", {
            orderNo: id,
            orderDetailList :orderDetailList,
            cancelResnCode : formData.cancelResnCode,
            cancelResnDetail :formData.cancelResnDetail,
            bankCd : formData.bankCd,
            bankAcctNo : formData.bankAcctNo,
            bankName : formData.bankName
        });
        
        if(response.data.resultCode === 200){     
            await alert(response.data.resultMessage);        
            window.location.href="/OrderHistory";      
        }else{
            alert(response.data.resultMessage);
        }

    }

    const handleKeyPress = (e,nextField ) => {      
        if(e.target.value.length === e.target.maxLength){
            if(nextField){
                setFocus(nextField);
            }          
        }else{
            e.target.value = e.target.value.replace(/[^0-9]/g, '');
            setValue(e.target.name,e.target.value.replace(/[^0-9]/g, ''), { shouldValidate: true })
            clearErrors(e.target.name)
        }
    };
    
    useEffect(() => {
        fetchData();
      }, []);
     
    return(
        <div>
            {data.orderDelivInfo && (data.orderDelivInfo.orderProcessSttusCode ==='ODR001' || data.orderDelivInfo.orderProcessSttusCode ==='ODR002' || data.orderDelivInfo.orderProcessSttusCode ==='ODR003')?(
            <>
            <div className="backGround bgBlue"></div>
            <Header type="cart" pageTitle={t(`Message.my_order_hist_list_order_cancel`)}/>

            <div className="pl20 pr20 pb40">
                <div className="ment">
                    <p>{t(`Message.my_order_cancel_msg1`)}</p>
                    <p>{t(`Message.my_order_cancel_msg2`)}</p>        
                </div>

                <div className="ocpContWr">
                    <div className="ocpList">
                        
                        {data.orderDelivDetailList && data.orderDelivDetailList.map((obj, index) => (  
                        <Product4 key={index}
                            type="type10"
                            img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+(obj.goodsImageSn?obj.goodsImageSn:0)}
                            prodName={obj.goodsNm}
                            option1={obj.firstOptnNm}
                            option2={obj.firstOptnValue}
                            disprice={"￦"+(!obj.sleAmount?0:obj.sleAmount).toLocaleString('ko-KR')}
                            qty={obj.orderQy}
                            obj ={obj}                            
                        />
                        ))}                         
                    </div>

                    <div className="rdoTxtWr">
                        <p className="tit">{t(`Message.my_order_cancel_reason`)}</p>
                        <ul className="radioList">
                            {data.cmDetailcodeList && data.cmDetailcodeList.map((obj, index) => (  
                            <li key={index}>
                                <input type="radio" name="cancelResnCode" id={obj.code} value={obj.code} {...register("cancelResnCode",{ required:"필수 응답 항목입니다."})}   />
                                <label htmlFor={obj.code}>{obj.codeNm}</label>
                            </li>
                             ))}
                            {errors.cancelResnCode && <p role="alert" className="alertRed">{errors.cancelResnCode.message}</p>}
                            {watch("cancelResnCode") === 'RSN999'?(
                            <li>
                                <textarea name="cancelResnDetail" {...register("cancelResnDetail")} placeholder={t(`Message.my_order_cancel_reason_hint`)}></textarea>
                            </li>
                            ):null}                            
                        </ul>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)}>
        
                    <div className="mb12">
                        <p className="tit">{t(`Message.my_order_cancel_refund_amt`)}</p>
                        <ul className="bwltrc">
                            <li className="dfsb">
                                <p className="fs15 fw700 cNavy">{t(`Message.my_order_cancel_refund_amt`)}</p>
                                <p className="fs15 fw700 cNavy">￦{!data.orderDelivInfo?0:data.orderDelivInfo.lastSetleAmount.toLocaleString('ko-KR')}</p>
                            </li>
                            <li>
                                <p>{t(`Message.my_order_cancel_amount_dlvy_amt`)}</p>
                                <p>￦{!data.orderDelivInfo?0:data.orderDelivInfo.dlvyCtAmount.toLocaleString('ko-KR')}</p>
                            </li>
                            <li>
                                <p>{t(`Message.my_order_cancel_amount_goods_amt`)}</p>
                                <p>￦{!data.orderDelivInfo?0:data.orderDelivInfo.sleGoodsAmount.toLocaleString('ko-KR')}</p>
                            </li>

                            {data.orderDelivInfo.pgCode === 'shinhan' && data.orderDelivInfo.payMethod === 'va'?(
                            <>
                            <li className="bwltrcCol">
                                <p>{t(`환불받을 은행`)}</p>
                                <div className="w100per">
                                    <select {...register("bankCd", { required:"필수 응답 항목입니다."})}>
                                        {data.cmDetailcodeList2 && data.cmDetailcodeList2.map((obj, index) => (  
                                        <option value={obj.code}>{obj.codeNm}</option>
                                        ))}
                                    </select>
                                    {errors.bankCd && <p role="alert" className="alertRed">{errors.bankCd.message}</p>}
                                </div>
                                
                            </li>
                            <li className="bwltrcCol">
                                <p>{t(`환불받을 계좌번호(-없이 입력)`)}</p>
                                <div className="w100per">
                                <input                                 
                                type="text" 
                                maxLength={14} 
                                onKeyUp={(e)=>handleKeyPress(e, "bankName")}
                                {...register("bankAcctNo", { required:"필수 응답 항목입니다."})}
                            />
                                {errors.bankAcctNo && <p role="alert" className="alertRed">{errors.bankAcctNo.message}</p>}
                                </div>
                                
                            </li>
                            <li className="bwltrcCol">
                                <p>{t(`Message.order_payment_result_screen_acunt_holder`)}</p>
                                <div className="w100per">
                                <input 
                                type="text" 
                                maxLength={60} 
                                {...register("bankName", { required:"필수 응답 항목입니다."})}                               
                            />
                                {errors.bankName && <p role="alert" className="alertRed">{errors.bankName.message}</p>}
                                </div>
                            </li>
                            </>
                            ):null}
                        </ul>
                    </div>
                   

                    <div className="chkWr">
                        <input type="checkbox" id="agr" onChange={(e)=>{setAgr(e.target.checked)}}/>
                        <label htmlFor="agr">{t(`Message.my_order_cancel_agree_at`)}</label>
                    </div>

                    <div className="pt20">
                        <button className="btn44 orgB cFFF" type="submit"  >{t(`Message.my_order_cancel_title`)}</button>
                    </div>
                    </form>
                </div>
            </div>
           </>
            ):null}
        </div>
    );
};